import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_47: FaireProductEntity = {
  token: "legacy_prod_abbott-47",
  type: "product",
  name: 'Lemon Shaped Enamel Bowl Yellow 5.5" L (Clearance)',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/d740fccdd44d378e35c6d9654deb7a7a78c159dfa480b71bfbe26a376a059f2e.jpeg",
  priceDollars: 14,
  msrpDollars: 28,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
